import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {
  MappedProductTransactionEntry,
  MappedProductWarehouseEntry,
  ProductRef,
  SchoolCheckoutRequestInput,
  SupportedSubs,
} from '../../../model/v3/transactions';
import {appendIfDefined} from './rest-v3-utils';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class TransactionsV3RestService {
  constructor(private http: HttpClient) {}

  private baseUrl(path: string): string {
    return `${environment.eventsApiBase}/v1/schools${path}`;
  }

  syncStudentsProducts(
    schoolId: number,
    studentId: number,
    products: ProductRef[],
  ): Observable<ProductRef[]> {
    return this.http.put<ProductRef[]>(
      this.baseUrl(`/${schoolId}/students/${studentId}/products`),
      products,
    );
  }

  syncTeacherProducts(
    schoolId: number,
    teacherId: number,
    products: ProductRef[],
  ): Observable<ProductRef[]> {
    return this.http.put<ProductRef[]>(
      this.baseUrl(`/${schoolId}/teachers/${teacherId}/products`),
      products,
    );
  }

  getStudentProducts(
    schoolId: number,
    studentId: number,
  ): Observable<MappedProductTransactionEntry[]> {
    return this.http.get<MappedProductTransactionEntry[]>(
      this.baseUrl(`/${schoolId}/students/${studentId}/products`),
    );
  }

  getTeacherProducts(
    schoolId: number,
    teacherId: number,
  ): Observable<MappedProductTransactionEntry[]> {
    return this.http.get<MappedProductTransactionEntry[]>(
      this.baseUrl(`/${schoolId}/teachers/${teacherId}/products`),
    );
  }

  getSchoolCredits(schoolId: number): Observable<MappedProductWarehouseEntry[]> {
    return this.http.get<MappedProductWarehouseEntry[]>(this.baseUrl(`/${schoolId}/credits`));
  }

  isTeacherSubscribed(schoolId: number, teacherId: number): Observable<boolean> {
    return this.getTeacherProducts(schoolId, teacherId).pipe(
      map(entries => entries.some(entry => entry.product?.mappedId === SupportedSubs.TeacherSub.mappedId)),
    );
  }


  createSchoolCheckout(
    platform: string | null,
    successUrl: string | null,
    errorUrl: string | null,
    cancelUrl: string | null,
    body: SchoolCheckoutRequestInput,
  ): Observable<string> {
    const params = [
      ['type', 'school'],
      ['platform', platform],
      ['successUrl', successUrl],
      ['errorUrl', errorUrl],
      ['cancelUrl', cancelUrl],
    ].reduce(
      (acc, [key, value]) => appendIfDefined(acc, key as string, value as string | number | boolean | null),
      new HttpParams(),
    );
    return this.http.post<void>(`${environment.eventsApiBase}/v1/checkouts`, body, {
      params,
      observe: 'response',
    }).pipe(
      map(res => res.headers.get('Location'))
    );

  }

}
